import { createContext, useContext } from "react";

import {
  type AddConditionAction,
  type ConditionBuild,
  type ConditionSlotId,
  type EffectBuild,
} from "@skilitics/nautilus-core-designer-data";

import { type CreateCondition, type GetCondition } from "./conditions/index.ts";
import type { AddEffect, CreateEffect, GetEffectBuildable, GetEffects } from "./effects/index.ts";
import type { ResolveAddableEffectBuildables } from "./querying/index.ts";

export interface ResponseDesignerContext {
  addEffect: AddEffect;
  getEffectBuilds: (responseId: number) => EffectBuild[];
  getEffects: GetEffects;
  updateEffect: (effectId: number, config: any) => void;
  reorderEffect: (effectId: number, newIndex: number) => void;
  removeEffect: (effectId: number) => void;

  createEffect: CreateEffect;
  getEffectBuildable: GetEffectBuildable;
  resolveAddableEffectBuildables: ResolveAddableEffectBuildables;

  addCondition: (condition: ConditionBuild, to: AddConditionAction["payload"]["to"]) => void;
  createCondition: CreateCondition;
  getCondition: GetCondition;
  moveCondition: (conditionId: number, newSlotId: ConditionSlotId, newIndex?: number) => void;
  removeCondition: (conditionId: number) => void;
  reorderCondition: (conditionId: number, newIndex: number) => void;
  updateCondition: (conditionId: number, config: any) => void;
}

export const ResponseDesignerContext = createContext<ResponseDesignerContext | undefined>(undefined);
ResponseDesignerContext.displayName = "ResponseDesignerContext";

export const useResponseDetailsDesigner = () => {
  const context = useContext(ResponseDesignerContext);
  if (!context) {
    throw new Error(`Expected ResponseByIdContext in component ancestry.`);
  }
  return context;
};
